<template>
  <section>
    <div
      id="details"
      class="contact-form"
    >
      <!-- Image -->
      <figure class="contact-form__image">
        <picture>
          <source
            media="--large"
            data-srcset="/static/images/banner.jpg,
            /static/images/banner@2x.jpg 2x,
            /static/images/banner@3x.jpg 3x"
          >

          <img
            class="lazyload"
            data-sizes="auto"
            data-src="/static/images/banner.jpg"
          >
        </picture>
      </figure>

      <!-- Title -->
      <title-view variant="small">
        {{ $t('contact_10') }}
      </title-view>

      <form
        class="grid"
        @submit.prevent="submitContact"
      >
        <div class="col-4_sm-12">
          <input-label-view
            v-model="name"
            label="contact_5"
          />
        </div>

        <div class="col-4_sm-12">
          <input-label-view
            v-model="email"
            type="email"
            label="contact_6"
          />
        </div>

        <div class="col-4_sm-12">
          <input-label-view
            v-model="phone"
            type="tel"
            label="contact_7"
          />
        </div>

        <div class="col-12">
          <input-text-view
            v-model="message"
            label="contact_8"
          />
        </div>

        <div class="col-12">
          <input-checkbox-view
            v-model="rgpdConcent"
            :class="{'hasError': !rgpdConcent && hasMissingConcent}"
            variant="inverted"
            type="checkbox"
            label="rgdp_concent"
            @updateValue="updateRgpdConcent"
          />
        </div>

        <button-view
          type="submit"
          variant="center special"
        >
          {{ $t('button_1') }}
        </button-view>
      </form>
    </div>

    <!-- Message (success) -->
    <message-view :show="show">
      <!-- Title -->
      <template slot="title">
        {{ $t('message_3') }}
      </template>

      <!-- Message -->
      <template slot="message">
        {{ $t('message_4') }}
      </template>

      <!-- Action -->
      <template slot="action">
        <button-view
          type="submit"
          variant="center special"
          @click.native="show = false"
        >
          {{ $t('message_6') }}
        </button-view>
      </template>
    </message-view>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ContactForm',

  components: {
    TitleView: () => import('@/components/title/title-view'),
    InputLabelView: () => import('@/components/input/input-label-view'),
    InputTextView: () => import('@/components/input/input-text-view'),
    ButtonView: () => import('@/components/button/button-view'),
    MessageView: () => import('@/components/message/message-view'),
    InputCheckboxView: () => import('@/components/input/input-checkbox-view')
  },

  data() {
    return {
      loading: false,
      show: false,

      name: '',
      email: '',
      phone: '',
      message: '',

      rgpdConcent: false,
      hasMissingConcent: false
    };
  },

  methods: {
    ...mapActions('contact', [
      'submitContactForm'
    ]),

    updateRgpdConcent(value) {
      this.rgpdConcent = value;
    },

    submitContact() {
      if (!this.rgpdConcent) {
        this.hasMissingConcent = true;
        return;
      }

      if (this.loading) {
        return;
      }

      this.loading = true;

      this.submitContactForm([
        this.name, this.email, this.phone, this.message, this.rgpdConcent
      ]).then(() => {
        this.loading = false;
        this.hasMissingConcent = false;
        this.$router.push({ name: 'contact-response' });
      });
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/contact/contact-form-view.scss"></style>



// WEBPACK FOOTER //
// contact-form-view.vue